module.exports = __webpack_public_path__ + "fonts/ChurchwardMarianna-Regular.3a280a60.woff2";